export const CHANGE_FY = 'CHANGE_FY';

export const LOGIN_RESPONSE = 'LOGIN_RESPONSE';
export const LOGIN_RESPONSE_FALSE = 'LOGIN_RESPONSE_FALSE'
// -------------- SIGN-UP --------------------------
export const SIGN_UP_ACT = 'SIGN_UP_ACT'
export const SIGN_UP_ERR = 'SIGN_UP_ERR'
export const SIGN_UP_CLEARE_TEMP = 'SIGN_UP_CLEARE_TEMP'
// -------------- CHANGE PASSWORD -----------------------
export const USER_PWD_CHG = 'USER_PWD_CHG'
// -------------- LOGOUT --------------------------------
export const LOGOUT = 'LOGOUT'
export const DESTROY_ISLOGIN = 'DESTROY_ISLOGIN'
// -------------- DASH BOARD ----------------------------
export const DASHBOARD = 'FETCH_DASH_DETAILS'
export const DASHBOARD_FINTECH = 'FETCH_DASH_FINTECH_DETAILS'

// plan payment
export const PLAN_EXPIRED = 'PLAN_EXPIRED';
export const CLEAR_PRIVATE_PAYMENT = 'CLEAR_PRIVATE_PAYMENT'

// ------- User -------
export const FETCH_USER = 'FETCH_USER';
export const ADD_USER = 'ADD_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const SINGLE_USER = 'SINGLE_USER';
export const DELETE_USER = 'DELETE_USER';

export const CLEAR_TEMP_USER = 'CLEAR_TEMP_USER';
export const CLEAR_USER = 'CLEAR_USER';

// -------------- TAXATION -------------------------------
export const TAX_LIST = "TAX_LIST";
export const CREATE_LIST = "CREATE_LIST"
export const CLEAR_TEMP_DATA = 'CLEAR_TEMP_DATA'
export const TAX_SINGLE = 'TAX_SINGLE'
export const TAX_UPDATE = 'TAX_UPDATE';
export const TAX_DELETE = 'TAX_DELETE'
export const CLEAR_LEDGER_TEMP_STATES = 'CLEAR_LEDGER_TEMP_STATES';
export const CLEARE_TEMP_TAX_DATA = 'CLEARE_TEMP_TAX_DATA'
// -------------- VNC ------------------------------------
export const VNC_LIST = "VNC_LIST"
export const VNC_STATE = 'VNC_STATE'
export const ADD_VNC = 'VNC_ADD'
export const VNC_UPDATE = 'VNC_UPDATE'
export const CUSTOMER_LIST = 'CUSTOMER_LIST'
export const VNC_SINGLE = 'VNC_SINGLE'
export const VNC_DELETE = 'VNC_DELETE'
export const VNC_CLEAR_TEMP = 'VNC_CLEAR_TEMP'
export const VNC_CLEAR_STATE = 'VNC_CLEAR_STATE'
export const VNC_HAVE_BANK = 'VNC_HAVE_BANK'
export const ADD_STATE_DETAILS = 'ADD_STATE_DETAILS'
export const SINGLE_VNC = 'SINGLE_VNC'
export const UPDATE_VNC = 'UPDATE_VNC'
export const VNC_CLEAR_TEMP_KEEP_BANK = 'VNC_CLEAR_TEMP_KEEP_BANK'
// ------------- UOM --------------------------------
export const UOM_CREATE = 'UOM_CREATE';
export const UOM_LIST = 'UOM_LIST';
export const UOM_SINGLE = 'UOM_SINGLE';
export const UOM_UPDATE = 'UOM_UPDATE';
export const UOM_DELETE = 'UOM_DELETE';
export const CLEAR_UOM_TEMP_STATES = 'CLEAR_UOM_TEMP_STATES';
export const CLEAR_UOM_STATES = 'CLEAR_UOM_STATES';

// -------------- INVOICE WOI ------------------------
export const INVOICE_WOI_STATE = 'INVOICE_WOI_STATE';
export const INVOICE_WOI_CREATE = 'INVOICE_WOI_CREATE';
export const INVOICE_WOI_EINVOICE_CREATE = 'INVOICE_WOI_EINVOICE_CREATE';
export const INVOICE_WOI_LIST = 'INVOICE_WOI_LIST';
export const INVOICE_WOI_NUMBER = 'INVOICE_WOI_NUMBER';
export const INVOICE_WOI_SEND = 'INVOICE_WOI_SEND';
export const INVOICE_WOI_SINGLE = 'INVOICE_WOI_SINGLE';
export const INVOICE_WOI_UPDATE = 'INVOICE_WOI_UPDATE';
export const INVOICE_WOI_DELETE = 'INVOICE_WOI_DELETE';

export const CLEAR_INVOICE_TEMP_STATES = 'CLEAR_INVOICE_TEMP_STATES';
export const CLEAR_INVOICE_STATES = 'CLEAR_INVOICE_STATES';
export const INVOICE_NUMBER = 'INVOICE_NUMBER'
export const CLEAR_INVOICE_TEMP_SENT = 'CLEAR_INVOICE_TEMP_SENT'

// ------ PURCHASE -------
export const PURCHASE_WOI_STATE = 'PURCHASE_WOI_STATE';
export const PURCHASE_WI_LOCAL = 'PURCHASE_WOI_LOCAL';
export const PURCHASE_ACCOUNT = 'PURCHASE_ACCOUNT'
export const PURCHASE_WI_CREATE = 'PURCHASE_WI_CREATE';
export const PURCHASE_WI_LIST = 'PURCHASE_WI_LIST';
export const PURCHASE_WI_SINGLE = 'PURCHASE_WI_SINGLE';
export const PURCHASE_WI_UPDATE = 'PURCHASE_WI_UPDATE';
export const PURCHASE_WI_DELETE = 'PURCHASE_WI_DELETE';

export const PURCHASE_WOI_CREATE = 'PURCHASE_WOI_CREATE';
export const PURCHASE_WOI_LIST = 'PURCHASE_WOI_LIST';
export const PURCHASE_WOI_SINGLE = 'PURCHASE_WOI_SINGLE';
export const PURCHASE_WOI_UPDATE = 'PURCHASE_WOI_UPDATE';
export const PURCHASE_WOI_DELETE = 'PURCHASE_WOI_DELETE';

export const CLEAR_PURCHASE_TEMP_STATES = 'CLEAR_PURCHASE_TEMP_STATES';
export const CLEAR_PURCHASE_STATES = 'CLEAR_PURCHASE_STATES';

// ------ EXPENSES -------
export const EXPENSE_CREATE = 'EXPENSE_CREATE';
export const EXPENSE_LIST = 'EXPENSE_LIST';
export const EXPENSE_SINGLE = 'EXPENSE_SINGLE';
export const EXPENSE_UPDATE = 'EXPENSE_UPDATE';
export const EXPENSE_DELETE = 'EXPENSE_DELETE';

export const CLEAR_EXPENSE_TEMP_STATES = 'CLEAR_EXPENSE_TEMP_STATES';
export const CLEAR_EXPENSE_STATES = 'CLEAR_EXPENSE_STATES';

// ------ PAYMENT -------
export const PAYMENT_PARTICULAR = 'PAYMENT_PARTICULAR';
export const PAYMENT_TOTALS = 'PAYMENT_TOTALS';

export const PAYMENT_CREATE = 'PAYMENT_CREATE';
export const PAYMENT_LIST = 'PAYMENT_LIST';
export const PAYMENT_VENPUR = 'PAYMENT_VENPUR';
export const PAYMENT_NUMBER = 'PAYMENT_NUMBER';
export const PAYMENT_SINGLE = 'PAYMENT_SINGLE';
export const PAYMENT_UPDATE = 'PAYMENT_UPDATE';
export const PAYMENT_DELETE = 'PAYMENT_DELETE';
export const PAYMENT_SEND = 'PAYMENT_SEND'
export const CLEAR_PAYMENT_TEMP_STATES = 'CLEAR_PAYMENT_TEMP_STATES';
export const CLEAR_PAYMENT_STATES = 'CLEAR_PAYMENT_STATES';
//  ------ Misc -------
export const MISC_PARTICULAR = 'MISC_PARTICULAR';
export const MISC_TOTALS = 'MISC_TOTALS';
export const FY_LIST = 'FY_LIST';

export const INVPUR_LIST = 'INVPUR_LIST';
export const INVPUR_TOTAL = 'INVPUR_TOTAL';

export const MISC_LOCALS = 'MISC_LOCALS';
export const STATE_DATA = 'STATE_DATA';
export const CLEAR_TEMP_MISC = 'CLEAR_TEMP_MISC';
export const CLEAR_MISC = 'CLEAR_MISC';


// ------ Lists -------
export const LIST_STATE = 'LIST_STATE';
export const LIST_ACTIVITY = 'LIST_ACTIVITY';
export const LIST_INVENTORY = 'LIST_INVENTORY';
export const CLEAR_LIST = 'CLEAR_LIST';

// ------ COMPANY ------
export const FETCH_COMPANY = 'FETCH_COMPANY';
export const UPSERT_COMPANY = 'UPSERT_COMPANY';
export const CLEAR_COMPANY_TEMP_STATES = 'CLEAR_COMPANY_TEMP_STATES';
export const CLEAR_COMPANY_STATE = 'CLEAR_COMPANY_STATE';
export const FETCH_LOGO = 'FETCH_LOGO'
// ----------------- BANK --------------------------
//documantion 1   export const STRING_NAME = 'STRING_NAME'; 
export const BANK_CREATE = 'BANK_CREATE';
export const BANK_LIST = 'BANK_LIST';
export const COMPANY_BANK_LIST = 'COMPANY_BANK_LIST';
export const BANK_SINGLE = 'BANK_SINGLE';
export const BANK_UPDATE = 'BANK_UPDATE';
export const BANK_DELETE = 'BANK_DELETE';
export const CLEAR_BANK_TEMP_STATES = 'CLEAR_BANK_TEMP_STATES';
export const CLEAR_BANK_STATES = 'CLEAR_BANK_STATES';


// ------ TERMS n COND ------
export const INVOICE_TC = 'INVOICE_TC';
export const INVOICE_TC_UPSERT = 'INVOICE_TC_UPSERT';

export const PAYRPT_TC = 'PAYRPT_TC';
export const PAY_TC_UPSERT = 'PAY_TC_UPSERT';
export const RPT_TC_UPSERT = 'RPT_TC_UPSERT';
export const PAYMENT_TC = 'PAYMENT_TC'
export const ProForma_TC = 'ProForma_TC'
export const ProForma_TC_UPSERT = 'ProForma_TC_UPSERT'
export const CLEAR_TEMP_DC = 'CLEAR_TEMP_DC';
export const CLEAR_DC = 'CLEAR_DC';

// ------- LEDGER -------------------------

export const LEDGER_CREATE = 'LEDGER_CREATE';
export const LEDGER_LIST = 'LEDGER_LIST';
export const LEDGER_SINGLE = 'LEDGER_SINGLE';
export const LEDGER_UPDATE = 'LEDGER_UPDATE';
export const LEDGER_DELETE = 'LEDGER_DELETE';
export const CLEAR_LEDGER_TEMP = 'CLEAR_LEDGER_TEMP';
export const CLEAR_LEDGER_STATES = 'CLEAR_LEDGER_STATES';
export const FETCH_LEDGER_P = 'FETCH_LEDGER_P'
// --------- GROUP -----------------------
export const AC_GROUP_LIST = 'AC_GROUP_LIST';
export const AC_GROUP_WITHID = 'AC_GROUP_WITHID';
export const CLEAR_AC_GROUP = 'CLEAR_AC_GROUP';

// ------ RECEIPTS -------
export const RECEIPT_PARTICULAR = 'RECEIPT_PARTICULAR';
export const RECEIPT_TOTALS = 'RECEIPT_TOTALS';
export const RECEIPT_CREATE = 'RECEIPT_CREATE';
export const RECEIPT_LIST = 'RECEIPT_LIST';
export const RECEIPT_CUSTINV = 'RECEIPT_CUSTINV';
export const RECEIPT_NUMBER = 'RECEIPT_NUMBER';
export const RECEIPT_SEND = 'RECEIPT_SEND';
export const RECEIPT_SINGLE = 'RECEIPT_SINGLE';
export const RECEIPT_UPDATE = 'RECEIPT_UPDATE';
export const RECEIPT_DELETE = 'RECEIPT_DELETE';
export const LEDGER_LIST_ACCOUNTS = 'LEDGER_LIST_ACCOUNTS'
export const CLEAR_RECEIPT_TEMP_STATES = 'CLEAR_RECEIPT_TEMP_STATES';
export const CLEAR_RECEIPT_STATES = 'CLEAR_RECEIPT_STATES';
export const FETCH_LEDGER_R = 'FETCH_LEDGER_R'
export const FETCH_LEDGER_E = 'FETCH_LEDGER_E'
// ---------- REPORT ---------------

export const FETCH_LEDGER_REPORT = 'FETCH_LEDGER_REPORT'
export const START_END_DATE = 'START_END_DATE'
export const CLEAR_REPORT_TEMP = 'CLEAR_REPORT_TEMP'
export const FETCH_PERTICULAR_REPORT = 'FETCH_PERTICULAR_REPORT'
export const FETCH_PERTICULAR_DEBTORS = 'FETCH_PERTICULAR_DEBTORS'

export const FETCH_GSTR1 = 'FETCH_GSTR1'
export const FETCH_SUB_GSTR = 'GET_SUB_GSTR1'
export const FETCH_GSTR1_SUB = 'FETCH_GSTR1_SUB'
export const CLEAR_RETURNS = 'CLEAR_RETURNS'

// ------------ HELP AND SUPPORT ---------
export const FETCH_HELP_SUPPORT = 'FETCH_HELP_SUPPORT'
export const CREATE_HELP_SUPPORT = 'CREATE_HELP_SUPPORT'
export const CLEAR_HELP_SUPPORT = 'CLEAR_HELP_SUPPORT'